/**
 * useGamepadConnectionEvent — the latest "a controller arrived / left", as React state.
 *
 * Returns a FRESH OBJECT per edge, deliberately. Consumers key on identity the way
 * `useRobotEventNotice` does, so a repeat of the same edge re-arms the notice instead of being
 * swallowed as an unchanged value.
 */

import { useEffect, useState } from 'react'

import type { GamepadConnectionEvent } from './gamepad-connection'
import { subscribeGamepadConnection } from './gamepad-connection-store'

export function useGamepadConnectionEvent(enabled = true): GamepadConnectionEvent | null {
  const [event, setEvent] = useState<GamepadConnectionEvent | null>(null)

  useEffect(() => {
    if (!enabled) return undefined

    return subscribeGamepadConnection(setEvent)
  }, [enabled])

  return event
}
